export default __webpack_public_path__ + "static/media/hostaway_step8.3a78fc75.jpg";